/** Subcollection name under examModules for study documents (document id = topic). */
export const SUBCOLLECTION_STUDY = 'studies';
